var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.959,
    height: 39.344,
    viewBox: "0 0 36.959 39.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond",
    transform: "translate(-15.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M33.429,31.112a10.82,10.82,0,0,1,16.689-9.086c.012-.8.018-1.657.018-2.58a97.344,97.344,0,0,0-.48-10.774H49.7A9.176,9.176,0,0,0,43.734,1c-.085-.032-.171-.063-.257-.092A9.173,9.173,0,0,0,41.512.479L41.448.472A51.814,51.814,0,0,0,33.105,0a58.455,58.455,0,0,0-8.8.476L24.24.483a9.157,9.157,0,0,0-2.06.461V.909A9.181,9.181,0,0,0,16,8.653a97.4,97.4,0,0,0-.483,10.793A97.4,97.4,0,0,0,16,30.239a9.19,9.19,0,0,0,8.19,8.189l.064.007a51.186,51.186,0,0,0,8.342.476c1.783,0,3.074-.023,4.087-.064a10.786,10.786,0,0,1-3.257-7.735Zm-8.991-20.88H41.215a1.83,1.83,0,1,1,0,3.661H24.442a1.83,1.83,0,0,1,0-3.661Zm0,11.494a1.831,1.831,0,1,1,0-3.662h9.568a1.831,1.831,0,1,1,0,3.662Z",
    transform: "translate(0 0)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M290.452,297.74a8.232,8.232,0,1,0,8.232,8.232A8.232,8.232,0,0,0,290.452,297.74Zm3.263,9.437h-3.427a.98.98,0,0,1-.98-.98v-5.264a.98.98,0,1,1,1.96,0v4.284h2.447a.98.98,0,1,1,0,1.96Z",
    transform: "translate(-246.205 -274.86)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.8e87bfc33abded95adb0eaae0ddf20d0.svg";
export { ForwardRef as ReactComponent };